import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { formConsumer } from 'core/form';
import { Flex } from 'core/components';

import ScriptDisplay from './utils/ScriptDisplay';
import { generatePolicy } from './utils/constants';

@inject('$cloudExportWizard')
@formConsumer
@observer
class OciPolicyPreview extends Component {
  get completePolicyDefinitions() {
    const { $cloudExportWizard } = this.props;

    return generatePolicy({
      crossTenancy: !$cloudExportWizard.getFieldValue('properties.oci_user_id'),
      includeFlowLogs: $cloudExportWizard.isFlowLogCollectionEnabled,
      includeMetrics: $cloudExportWizard.isMetricsCollectionEnabled
    });
  }

  render() {
    return (
      <Flex data-testid="OciPolicyPreviewStep" flexDirection="column">
        <ScriptDisplay
          source={this.completePolicyDefinitions.join('\r')}
          data={{
            kentikTenancyId: 'ocid1.tenancy.oc1..aaaaaaaaau7s2ul5f4egoc5ogvofp22gt6y6gps6vxco7huazjvke5lcvfrq',
            kentikUserGroup: 'ocid1.group.oc1..aaaaaaaa3jokhabvvocsywjvlckfvzda75uzkf7obh3q7ph22z7bm6ff6dvq'
          }}
        />
      </Flex>
    );
  }
}

export default OciPolicyPreview;
